import { Routes } from '@angular/router';
import { productGuard } from 'app/core/guards/product.guard';

export const tksRoutes: Routes = [
    {
        path: 'dashboard/simple-tks',
        title: 'Simple TKS',
        canActivate: [productGuard('tks')],
        loadComponent: () =>
            import('app/products/productivity/dashboards/simple-tks/simple-tks.component').then(
                m => m.SimpleTksComponent
            ),
    },
];
